/* Program Name: App.js
 **  Description: the main Parent Component of the the application
 **
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-03-17  STT  Initial program
 *********************************************************************************/

/**React Router imports */
import { BrowserRouter } from 'react-router-dom'

/**MUI imports */
import { CssBaseline } from '@mui/material'

/**Custom Component imports */
import AppSwitch from './AppSwitch'

/**Fonts imports */
import './Fonts/krystalfont1.ttf'

/**Context imports */
import SessionProvider from './Context/SessionContext'
import AlertProvider from './Context/AlertContext'
import CustomThemeProvider from './Context/CustomThemeContext'
import CartContext from './Context/CartContext'
import DomainContext from './Context/DomainContext'
import LoadingContext from './Context/LoadingContext'
import ProxyContext from './Context/ProxyContext'

/**App ************************************************************************/
function App() {
  /****************************************************************************/
  /**Rendering */

  return (
    <BrowserRouter>
      <ProxyContext>
        <LoadingContext>
          <SessionProvider>
            <DomainContext>
              <CustomThemeProvider>
                <AlertProvider>
                  <CartContext>
                    <CssBaseline />
                    <AppSwitch />
                  </CartContext>
                </AlertProvider>
              </CustomThemeProvider>
            </DomainContext>
          </SessionProvider>
        </LoadingContext>
      </ProxyContext>
    </BrowserRouter>
  )
}

export default App
